// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"c57f308d","203":"23b048ac","284":"11d6aacc","397":"d2684f73","626":"36aa7f38","849":"78671ec3"}[chunkId] + ".chunk.js";
};